import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, CheckCircle } from "lucide-react";
import { buildWhatsAppUrl } from "@/lib/whatsapp";

// Sitewide pre-footer CTA. Hidden on portal/admin/splash pages and on
// Contact (where the user is already filling out the form).
export default function PreFooterCTA() {
  const { pathname } = useLocation();

  const hide =
    pathname === "/splash" ||
    pathname === "/contact" ||
    pathname.startsWith("/admin") ||
    pathname === "/patient" ||
    pathname.startsWith("/patient/") ||
    pathname.startsWith("/partner");

  if (hide) return null;

  return (
    <section
      data-testid="prefooter-cta"
      className="relative section-padding overflow-hidden bg-gradient-to-br from-[#03045e] via-[#023e8a] to-[#00A4A9]"
    >
      <div className="absolute -top-32 -right-32 w-96 h-96 rounded-full bg-[#00A4A9]/30 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-32 -left-32 w-96 h-96 rounded-full bg-[#48cae4]/15 blur-3xl pointer-events-none" />
      <div className="relative max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
        <h2 className="font-outfit text-3xl sm:text-4xl md:text-5xl font-medium text-white tracking-tight mb-5">
          Ready to begin your medical journey?
        </h2>
        <p className="text-slate-200/80 text-base sm:text-lg mb-10 max-w-2xl mx-auto leading-relaxed">
          Get a free consultation and a personalized treatment plan from our Kerala specialists.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/contact" data-testid="prefooter-cta-consult-btn">
            <Button
              size="lg"
              className="rounded-full bg-[#00A4A9] hover:bg-[#008084] text-white px-8 h-12 text-base"
            >
              Get Free Consultation <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </Link>
          <a
            href={buildWhatsAppUrl("Hi, I'd like a free consultation.")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="prefooter-cta-whatsapp-btn"
          >
            <Button
              size="lg"
              variant="outline"
              className="rounded-full border-white/30 bg-transparent text-white hover:bg-white/10 px-8 h-12 text-base"
            >
              Chat on WhatsApp
            </Button>
          </a>
        </div>
        <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4 sm:gap-8 text-sm text-slate-200/70">
          <span className="flex items-center justify-center gap-2">
            <CheckCircle className="w-4 h-4 text-[#90e0ef]" /> Free Consultation
          </span>
          <span className="flex items-center justify-center gap-2">
            <CheckCircle className="w-4 h-4 text-[#90e0ef]" /> No Obligation
          </span>
          <span className="flex items-center justify-center gap-2">
            <CheckCircle className="w-4 h-4 text-[#90e0ef]" /> 48hr Response
          </span>
        </div>
      </div>
    </section>
  );
}
